const withValuePayload = (value) => ({ payload: { value } });

const emptyPayload = () => ({ payload: {} });

// Replica el comportamiento de redux-actions con Errors: si el arg es un Error
// el payload es el Error directamente (con action.error = true), sino se envuelve
// como { error }. Los reducers legacy hacen action.payload.error, que devuelve
// undefined en el primer caso y el objeto de API en el segundo.
const withErrorPayload = (error) =>
  error instanceof Error
    ? { payload: error, error: true }
    : { payload: { error } };

export { withValuePayload, emptyPayload, withErrorPayload };
